export const APPLICATION = "supplier";
export const ENVIRONMENT = "prod";
export const BACKEND = "";
export const KEYCLOAK_JS_URL = "https://api-builder.gjgardner.com.au/auth/js/keycloak.js";
export const KEYCLOAK_JSON_URL = "";
export const KEYCLOAK_MIN_VALIDITY = 5;
export const KEYCLOAK_AUTH_SERVER_URL = "https://api-builder.gjgardner.com.au/auth";
export const KEYCLOAK_REALM = "GH-SPortal-AU";
export const KEYCLOAK_RESOURCE = "GH-SPortal-WebApp-AU";
export const KEYCLOAK_SECRET = "";
export const API_BASE_URL = "https://api-builder.gjgardner.com.au/sp/rest";
export const API_SB_URL = "/";
export const ENV_BASE_URL = "https://api-builder.gjgardner.com.au";
export const NODE_ENV = "production";
export const REGION_CODE = "au";
export const CONTEXT_PATH = "/";
export const VERSION = "5.2.21";
export const RELEASE = "supplier@5.2.21";
export const APP_NAME = "Supplier Portal";
export const DEFAULT_LOCALE = "en_AU";
export const LOCALES_CONTEXT_FILTER = /(en|en-AU|en-US|en-NZ)\.js$/;
export const DEFAULT_EMAIL_SUFFIX = "en_US";
export const DEFAULT_COUNTRY_CODE = undefined;
export const SCAYT_SERVICE_ID = undefined;
export const IGNORE_DIRTY_CHANGES = false;
export const ANGULAR_PROD_MODE = true;
export const AUTH_MODE = "keycloak";
export const AUTH_MODE_INDEX = 0;
export const MOCK_AUTH_MODE_PREDEFINED_USERS = [];
export const TODO_CHECK_ENABLED = undefined;
export const TODO_CHECK_INTERVAL = undefined;
export const MAINTENANCE_CHECK_ENABLED = undefined;
export const MAINTENANCE_CHECK_INTERVAL = undefined;
export const PRODUCE_STATUS_CHECK_INTERVAL = undefined;
export const AUTOMATION_GRID = false;
export const GOOGLE_CLIENT_ID = undefined;
export const GOOGLE_DEFAULT_SCOPES = undefined;
export const GOOGLE_UX_MODE = undefined;
export const GOOGLE_HOSTED_DOMAIN = undefined;
export const GOOGLE_ANALYTICS_ID = "G-WR6J987HB2";
export const SENTRY_ON = true;
export const SENTRY_DSN = "https://ada10ce94c62427ba19086ebcd06ad29@sentry.io/1423017";
export const HELP_URL = "";
export const DEFAULT_CURRENCY_TEMPLATE = "{sign}${number}";
export const EXPERIMENTS_DEV_MODULE = false;
export const MOCK_BACKEND_DEV_MODULE = false;
export const IE_11_DEV_MODE = false;
export const HELP_DEV_MODE = false;